import { render, staticRenderFns } from "./TableSwitch.vue?vue&type=template&id=4b59ff74&"
import script from "./TableSwitch.vue?vue&type=script&lang=js&"
export * from "./TableSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports